import { FormContent } from "../../types/roiCalculator";

interface FormValues {
  numOfPts: string;
  sessions: string;
  time: string;
  salary: string;
}

interface RoiFormProps {
  formContent: FormContent;
  formValues: FormValues;
  onFormChange: (field: keyof FormValues, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  submitButtonText: string;
  onRefresh?: () => void;
}

const RoiForm = ({
  formContent,
  formValues,
  onFormChange,
  onSubmit,
  submitButtonText,
  onRefresh,
}: RoiFormProps) => {
  return (
    <div className="w-full bg-white/80 backdrop-blur-sm rounded-lg p-8 shadow-lg flex-1 flex flex-col">
      <div className="flex items-center justify-center gap-3 mb-6">
        <h3 className="text-2xl font-bold text-slate-800 font-productSans">
          Calculate My Returns Now!
        </h3>
        {onRefresh && (
          <button
            onClick={onRefresh}
            type="button"
            className="p-2 text-slate-600 hover:text-[#1e3d3b] transition-colors"
            title="Reset Form"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
      <form className="flex flex-col gap-6 flex-1" onSubmit={onSubmit}>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            {formContent.numOfPts.label}
          </label>
          <select
            className="mt-1 block w-full border border-slate-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
            value={formValues.numOfPts}
            onChange={(e) => onFormChange("numOfPts", e.target.value)}
          >
            <option value="" disabled>
              {formContent.numOfPts.placeholder}
            </option>
            {formContent.numOfPts.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            {formContent.sessions.label}
          </label>
          <select
            className="mt-1 block w-full border border-slate-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
            value={formValues.sessions}
            onChange={(e) => onFormChange("sessions", e.target.value)}
          >
            <option value="" disabled>
              {formContent.sessions.placeholder}
            </option>
            {formContent.sessions.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            {formContent.documentTime.label}
          </label>
          <select
            className="mt-1 block w-full border border-slate-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
            value={formValues.time}
            onChange={(e) => onFormChange("time", e.target.value)}
          >
            <option value="" disabled>
              {formContent.documentTime.placeholder}
            </option>
            {formContent.documentTime.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            {formContent.salary.label}
          </label>
          <select
            className="mt-1 block w-full border border-slate-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
            value={formValues.salary}
            onChange={(e) => onFormChange("salary", e.target.value)}
          >
            <option value="" disabled>
              {formContent.salary.placeholder}
            </option>
            {formContent.salary.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="mt-auto pt-6">
          <button
            type="submit"
            className="w-full bg-[#1e3d3b] text-white font-semibold px-6 py-3 rounded-md hover:bg-[#2a5a56] transition-colors"
          >
          {submitButtonText}
        </button>
        </div>
      </form>
    </div>
  );
};

export default RoiForm;
